import React from 'react';
import ServiceCard from './services/ServiceCard';
import SectionBackground from './ui/SectionBackground';
import { services } from '../data/services';
import { colors } from '../styles/theme';

const Services: React.FC = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-white to-blue-50/50">
      <SectionBackground variant="right" color={colors.secondary} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des outils professionnels et un accompagnement personnalisé pour votre réussite
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;